import { Injectable } from '@angular/core';
import { HttpClient,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor(private http: HttpClient) {}

  uploadToCloud(file: File, orgId: number): Observable<{ fileName: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ fileName: string }>(
      `${environment.localApiUrl}store/upload/cloud/${orgId}`,
      formData
    );
  }

  /** upload con progress */
  uploadWithProgress(file: File, orgId: number): Observable<HttpEvent<{ fileName: string }>> {
    const formData = new FormData();
    formData.append('file', file);
    const req = new HttpRequest('POST', `${environment.localApiUrl}store/upload/cloud/${orgId}`, formData, {
      reportProgress: true
    });
    return this.http.request<{ fileName: string }>(req);
  }
}
